import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import DialogContent from "@mui/material/DialogContent";
import DialogHeader from "core/components/DialogHeader";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 200,
}));

const LoadingBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
}));

export default function Loading({ onClose }) {
  const { t } = useTranslation("arena");

  return (
    <>
      <DialogHeader onClose={onClose} title="" />
      <StyledDialogContent>
        <LoadingBox>
          <CircularProgress size={48} />
          <Typography variant="body1" color="textSecondary">
            {t("smobile.activating")}
          </Typography>
        </LoadingBox>
      </StyledDialogContent>
    </>
  );
}

Loading.propTypes = {
  onClose: PropTypes.func.isRequired,
};
